import { toast } from 'react-toastify';

export const notify = (type, message) => {
    toast.dismiss();
    toast[type](message, { toastId: message });
};
